'use client'

import AudioVisualizer from '@components/primitives/AudioVisualizer/index.client'
import { Icon } from '@components/primitives/Icon'
import PowerMark from '@components/primitives/PowerMark'
import { faWaveform } from '@fortawesome/pro-solid-svg-icons/faWaveform'

export function LiveAIAgent({
  mediaRecorder,
}: {
  mediaRecorder?: MediaRecorder
}) {
  return (
    <div className='z-10 flex flex-col'>
      <div className='flex flex-row items-center gap-1'>
        {mediaRecorder && mediaRecorder.state === 'recording' ? (
          <AudioVisualizer
            height={64}
            mediaRecorderInstance={mediaRecorder}
            width={128}
          />
        ) : (
          <div className='flex h-16 w-32 items-center justify-center rounded-md bg-primary200'>
            <Icon
              className='h-12 animate-pulse text-primary600'
              icon={faWaveform}
              size='4x'
            />
          </div>
        )}
        <div className='-ml-8 flex size-16 items-center justify-center rounded-full border-4 border-white bg-primary50'>
          <PowerMark />
        </div>
        <div className='flex flex-col items-start gap-0'>
          <div className='text-sm font-medium uppercase'>
            You&apos;re Speaking To
          </div>
          <div className='text-lg font-bold'>Virtual Patient Navigator</div>
        </div>
      </div>
    </div>
  )
}
